import { Link } from '@tanstack/react-router'
import { AdminStats } from '../services/adminService'
import { useTranslation } from '../i18n/hooks/useTranslation'

interface StatsGridProps {
  stats: AdminStats | undefined
  clickable?: boolean
}

export function StatsGrid({ stats, clickable = false }: StatsGridProps) {
  const { t } = useTranslation()

  const statItems = [
    {
      title: t('navigation.categories'), 
      value: stats?.categoriesCount || 0,
      color: 'text-gray-900',
      description: t('dashboard.stats.categories'),
      link: '/categories',
      icon: '📂'
    },
    {
      title: t('navigation.languages'),
      value: stats?.languagesCount || 0,
      color: 'text-gray-900',
      description: t('dashboard.stats.languages'),
      link: '/languages',
      icon: '🌐'
    },
    {
      title: t('navigation.users'),
      value: stats?.usersCount || 0,
      color: 'text-gray-900', 
      description: t('dashboard.stats.users'),
      link: '/users',
      icon: '👥'
    },
    {
      title: t('navigation.challenges'),
      value: stats?.challengesCount || 0,
      color: 'text-gray-900',
      description: t('dashboard.stats.challenges'), 
      link: '/analytics',
      icon: '🎯'
    }
  ]

  const StatCard = ({ item }: { item: typeof statItems[0] }) => (
    <div className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-lg font-semibold text-gray-900">{item.title}</h3>
        <span className="text-2xl">{item.icon}</span>
      </div>
      <p className={`text-3xl font-bold ${item.color}`}>{item.value}</p>
      <p className="text-sm text-gray-500">{item.description}</p>
    </div>
  )

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {statItems.map((item) => (
        <div key={item.title}>
          {clickable ? (
            <Link to={item.link} className="block cursor-pointer">
              <StatCard item={item} />
            </Link>
          ) : (
            <StatCard item={item} />
          )}
        </div>
      ))}
    </div>
  )
} 